import CaseComponent from './components/case/CaseComponent';
import React from 'react';
import './App.css';
import './header.css';
import { useState } from 'react';

import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'





function App() {
  // let meta = {
  //   url: "https://lastofthefirst.github.io/bgrm/",
  //   metaImg: 'https://ridvan.org/meta.jpg',
  //   description: "Free in browser background removal for your images.",
  //   title: "Background removal - Ridván - Software Consultancy",
  // }

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navigation = [
    { name: 'Consulting', href: 'https://ridvan.org?utm_source=removebackgroundapp' },
    { name: 'Textbook', href: 'https://textbook.ridvan.org?utm_source=removebackgroundapp' },
    { name: 'Reflect', href: 'https://reflect.ridvan.org?utm_source=removebackgroundapp' },
    { name: 'About', href: 'https://ridvan.org/about?utm_source=removebackgroundapp' },
  ]



    return (
      <div>
 <head>
        <title>Background removal - Ridván - Software Consultancy</title>
      </head>
      <header className="bg-gray-900">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
          <a href="https://ridvan.org?utm_source=removebackgroundapp" className="-m-1.5 p-1.5">
            <span className="sr-only">Ridván</span>
            <img className="h-8 w-auto" src="https://www.ridvan.org/nextImageExportOptimizer/ridvand.0ccc840f-opt-1080.WEBP" alt="" />
          </a>
        </div>
        <div className="flex lg:hidden">
          {/* <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button> */}
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <a key={item.name} href={item.href} className="text-sm font-semibold leading-6 text-white">
              {item.name}
            </a>
          ))}
        </div>
        {/* <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a href="#" className="text-sm font-semibold leading-6 text-white">
          Log in <span aria-hidden="true">&rarr;</span>
          </a>
        </div> */}
      </nav>
      {/* <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-gray-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-white/10">
        <div className="flex items-center justify-between">
        <a href="#" className="-m-1.5 p-1.5">
        <span className="sr-only">Your Company</span>
        <img
        className="h-8 w-auto"
        src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=500"
        alt=""
        />
        </a>
        <button
        type="button"
        className="-m-2.5 rounded-md p-2.5 text-gray-400"
        onClick={() => setMobileMenuOpen(false)}
        >
        <span className="sr-only">Close menu</span>
        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
        </div>
        <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/25">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <a
                  key={item.name}
                  href={item.href}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:bg-gray-800"
                  >
                  {item.name}
                  </a>
                  ))}
                  </div>
                  <div className="py-6">
                  <a
                  href="#"
                  className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-white hover:bg-gray-800"
                  >
                  Log in
                  </a>
                  </div>
                  </div>
                  </div>
                  </Dialog.Panel>
                </Dialog> */}
    </header>
    <div className="App">
     
      <CaseComponent />
    </div>
                </div>
  );
}

export default App;
